function i18nPlugin({ app, $api, store }) {
  app.i18n.onBeforeLanguageSwitch = (_, newLocale) => {
    store.dispatch("config/load", { $api, locale: newLocale });
    store.dispatch("menus/load", { $api, locale: newLocale });
  };
}
;
export {
  i18nPlugin as default
};
